module.exports = __webpack_public_path__ + "img/t4.8ebe6215.jpg";